module.exports = __webpack_public_path__ + "static/img/nav_hand.7c9a977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengwen_2018/nav_hand.png
// module id = bq5E
// module chunks = 0